module.exports = __webpack_public_path__ + "static/media/lightbulb.8a817860.svg";